/**
 * Converts a Uint8Array to a base64 encoded string
 */
export function uint8ArrayToBase64(bytes: Uint8Array): string {
  let str = ""
  for (const p of bytes) {
    str += String.fromCharCode(p)
  }
  return btoa(str)
}

/**
 * Converts a base64 encoded string back to a Uint8Array
 */
export function base64ToUint8Array(base64: string): Uint8Array {
  const binaryString = atob(base64)
  const bytes = new Uint8Array(binaryString.length)
  for (let i = 0; i < binaryString.length; i++) {
    bytes[i] = binaryString.charCodeAt(i)
  }
  return bytes
}
